import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";

// Placeholder images (replace with actual image paths)

const Dashboard = () => {
  useEffect(() => {
    // Add your effect logic here if needed
  }, []);

  const data = [
    {
      number: 20,
      text: "Video Files",
      image: "./video-file.png",
      backgroundColor: "#9971A6",
    },
    {
      number: 5,
      text: "Image Files",
      image: "./image-file.png",
      backgroundColor: "#6D8BC7",
    },
    {
      number: 10,
      text: "Html Files",
      image: "./html-file.png",
      backgroundColor: "#89A968",
    },
    {
      number: 15,
      text: "Word Files",
      image: "./word-files_.png",
      backgroundColor: "#00BA96",
    },
    {
      number: 25,
      text: "JavaScript Files",
      image: "./JS-File_.png",
      backgroundColor: "#E69100",
    },
  ];

  return (
    <Container className="mt-4 p-4" >
      <Row>
        {data.map((item, index) => (
          <Col key={index} md={3} className="mb-4">
            <Card style={{ backgroundColor: item.backgroundColor }}>
              <Card.Body className="d-flex justify-content-between align-items-center">
                <div>
                  <h3 style={{ fontSize: "2.5rem", color: "white" }}>
                    {item.number}
                  </h3>
                  <p style={{ fontSize: "0.9rem", color: "white" }}>
                    {item.text}
                  </p>
                </div>
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.text}
                    style={{ width: "50px", height: "60px" }}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Dashboard;
